import * as React from 'react';

function ThinDividerCurveSvg(props) {
    return (
        <svg
            width="100%"
            height="6"
            viewBox="0 0 689 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            preserveAspectRatio="none"
        >
            <path
                d="M2.99188 4.51951C48.0313 5.1904 93.1295 5.86128 138.365 5.98178C160.806 6.0404 183.267 5.96224 205.669 5.67891C228.111 5.39557 250.376 4.85495 272.661 4.33387C294.73 3.81605 316.838 3.37639 339.104 3.14842C361.643 2.9172 384.241 2.8488 406.839 2.82601C451.82 2.78693 496.879 2.94325 541.781 2.41892C584.275 1.92389 627.748 0.696104 670.104 2.04765C675.274 2.21374 680.365 2.41892 685.418 2.66317C689.53 2.86183 690.274 1.4191 686.749 1.24975C645.254 -0.749886 601.801 0.103378 559.523 0.718901C514.66 1.37025 469.738 1.35396 424.757 1.35722C379.815 1.36048 334.933 1.50052 290.285 2.46777C268.02 2.94976 245.852 3.54574 223.548 3.94307C201.009 4.34364 178.352 4.52276 155.695 4.53905C110.225 4.57487 64.8526 3.97563 19.5977 3.31126C13.9972 3.22984 8.39661 3.14517 2.79605 3.06049C-0.983343 3.00513 -0.944178 4.46089 2.99188 4.51951Z"
                fill="#E5E5E5"
            />
        </svg>
    );
}

export default ThinDividerCurveSvg;
